import {__} from "./__";

export const getComplaintTypes = () => {
    return {
        repair: __('Oprava'),
        change: __('Výmena'),
        discount: __('Zľava'),
        delivery: __('Dodanie'),
        cancel: __('Odstúpenie od zmluvy'),
    };
};
